<template>
  <div class="mb-20px">
    <input
      ref="fileInput"
      type="file"
      accept=".pdf,.docx,.xlsx,.xls"
      @change="handleFileSelect"
      style="display: none"
    />
    <AppButton variant="primary" @click="fileInput.click()">
      <AppIcon color="white" type="upload" size="18" class="mr-5px" />
      Upload document
    </AppButton>
    <p class="text-muted font-12px mt-8px">Supported: PDF, Word (.docx), Excel (.xlsx, .xls)</p>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { AppButton, AppIcon } from "@/components/ui";

const emit = defineEmits(["select"]);
const fileInput = ref(null);

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  emit("select", file);
  if (fileInput.value) fileInput.value.value = "";
};
</script>
